import ModalAppV2 from "@components/ModalAppV2";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setWelcomeMessage } from "@redux/actions/administrador/auth/auth";
import { SafeHtml } from "@components/SafeHtml";

export const WelcomeMessageModal = () => {
    const { welcomeMessage } = useSelector((state) => state.auth);

    if (!!welcomeMessage) {
        return (
            <ModalAppV2
                titleModal={welcomeMessage.name}
                size="lg"
                backdrop="static"
                keyboard={false}
                openModal={!!welcomeMessage}
                Action={() => <></>}
                hiddenCloseButton
            >
                <WelcomeMessageForm welcomeMessage={welcomeMessage} />
            </ModalAppV2>
        );
    } else {
        return null;
    }
};

const WelcomeMessageForm = ({ welcomeMessage }) => {
    const dispatch = useDispatch();
    const [secondsLeft, setSecondsLeft] = useState(10);

    const handleClose = () => {
        dispatch(setWelcomeMessage());
    };

    useEffect(() => {
        if (secondsLeft > 0) {
            const timer = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [secondsLeft]);

    return (
        <>
            <Modal.Body>
                <SafeHtml
                    html={welcomeMessage?.content || ""}
                    as="div"
                    className="ql-content"
                />
            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-end align-items-center">
                <Button
                    className="btn-block margin-0"
                    variant="primary"
                    onClick={handleClose}
                    disabled={secondsLeft > 0}
                >
                    {secondsLeft > 0
                        ? `El mensaje se podrá cerrar en ${secondsLeft} segundos`
                        : "Cerrar"}
                </Button>
            </Modal.Footer>
        </>
    );
};
